import { clientEnv } from '@retailer-platform/dashboard/env'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

// Helper to bypass permissions in local development
const isLocalDev = clientEnv.PUBLIC_CLIENT_ENVIRONMENT === 'local'

// View access for the main takedown page (list investigations)
// Available to all internal admins with the view permission
export const catalogAdminPriceAnomalyTakedownAccessConfiguration: DomainAccessControlConfig =
  isLocalDev
    ? {}
    : {
        permissions: Permission.PriceAnomalyInvestigationViewAccess,
      }

// Create access for creating new investigations
export const catalogAdminPriceAnomalyTakedownCreateAccessConfiguration: DomainAccessControlConfig =
  isLocalDev
    ? {}
    : {
        permissions: Permission.PriceAnomalyInvestigationCreateAccess,
      }

// Patch access for creating/deactivating patches
export const catalogAdminPriceAnomalyTakedownPatchAccessConfiguration: DomainAccessControlConfig =
  isLocalDev
    ? {}
    : {
        permissions: Permission.PriceAnomalyInvestigationPatchAccess,
      }
